import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './SimpleAdmin.css';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const SimpleAdmin = () => {
  const [applications, setApplications] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchApplications();
  }, []);

  const fetchApplications = async () => {
    try {
      const response = await axios.get(`${API_URL}/applications`);
      setApplications(response.data);
      setLoading(false);
    } catch (err) {
      console.error('Error:', err);
      setLoading(false);
    }
  };

  const viewResume = (id) => {
    window.open(`${API_URL}/applications/${id}/resume/view`, '_blank');
  };

  const downloadResume = (id) => {
    window.location.href = `${API_URL}/applications/${id}/resume/download`;
  };

  if (loading) {
    return (
      <div className="admin-container">
        <div className="loading">Loading applications...</div>
      </div>
    );
  }

  return (
    <div className="admin-container">
      <h1>Job Applications - HR View</h1>
      
      {applications.length === 0 ? (
        <div className="no-applications">No applications yet.</div>
      ) : (
        applications.map((app) => (
          <div key={app._id} className="app-card">
            <h2>{app.name} - {app.jobTitle}</h2>
            <p><strong>Email:</strong> {app.email}</p>
            <p><strong>Phone:</strong> {app.phone || 'N/A'}</p>
            {app.portfolio && (
              <p><strong>Portfolio:</strong> <a href={app.portfolio} target="_blank" rel="noopener noreferrer">{app.portfolio}</a></p>
            )}
            {app.experience && (
              <p><strong>Experience:</strong> {app.experience}</p>
            )}
            {app.coverNote && (
              <p><strong>Cover Note:</strong> {app.coverNote}</p>
            )}
            <p><strong>Status:</strong> <span className={`status-badge ${app.status}`}>{app.status}</span></p>
            <p><strong>Applied:</strong> {new Date(app.createdAt).toLocaleDateString()}</p>
            
            {app.resumePath && (
              <div className="resume-actions">
                <button 
                  onClick={() => viewResume(app._id)}
                  className="btn-view"
                >
                  👁️ View Resume
                </button>
                
                <button 
                  onClick={() => downloadResume(app._id)}
                  className="btn-download"
                >
                  ⬇️ Download Resume
                </button>
                
                {app.resumeOriginalName && (
                  <span className="resume-name">
                    📄 {app.resumeOriginalName}
                  </span>
                )}
              </div>
            )}
          </div>
        ))
      )}
    </div>
  );
};

export default SimpleAdmin;
